import { handleActions } from 'redux-actions';
import actions from '../actions';

const { reset, update, modal } = actions.member;

const defaultState = {
  showModal: false,
  id: '',
  mobile: '',
  points: 0,
  name: '',
};

const member = handleActions(
  {
    [reset]: () => defaultState,
    [update]: (state, { payload }) => ({ ...state, ...payload }),
    [modal.toggle]: state => ({ ...state, showModal: !state.showModal }),
  },
  defaultState
);

export default member;



// WEBPACK FOOTER //
// ./src/reducers/member.js